import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_83: FaireProductEntity = {
  token: "starter_collection_83",
  type: "product",
  name: "Oat White Potholders",
  brandName: "Hedley & Bennett",
  imageUrl:
    "https://cdn.faire.com/fastly/733e3a308b8f5785756501bd23ff6833250e0fd7fb1c7ca38c2aa2e1c5121d66.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 35,
  msrpDollars: 70,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
